module.exports = __webpack_public_path__ + "static/social-cover-230ffed28eb077974a3820396f524327.jpg";